/**
 * CANDIDATE COPY, not approved: awaiting Charles's approval before merge (verifime-adr#617).
 *
 * Every string IdentityTypeRow shows by default. A string marked CANDIDATE is new copy. The type
 * label and description are not here: the parent passes them as props, from the entity type copy
 * as built (EntityTypeSelector). The caller can replace any string below through props.
 */

export const IDENTITY_TYPE_ROW_COPY = {
  // CANDIDATE COPY, not approved (verifime-adr#617)
  heldCount: (count: number) => `${count} held`,
  // CANDIDATE COPY, not approved (verifime-adr#617)
  scrollCue: 'Show more identities',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  scrollBack: 'Show earlier identities',
};
